import AutoTagAPI from "../../../../src/pages/apis/accessibility-auto-tag-api/auto-tag-api-key-feature.md";
import BenefitsOfAccessibilityTitle from "../../../../src/pages/apis/accessibility-auto-tag-api/benefits-of-accessibility-title.md";
import BenefitsOfAccessibilityContent from "../../../../src/pages/apis/accessibility-auto-tag-api/benefitsOfAccessibilityContent.md";
import TechnicalUsecase from "../../../../src/pages/apis/accessibility-auto-tag-api/technical-usecase.md";
import IndustryUsecase from "../../../../src/pages/apis/accessibility-auto-tag-api/industry-usecase.md";
import PdfAccessibility from "../../../../src/pages/apis/accessibility-auto-tag-api/pdf-accessibility.md";
import AccessibilityAdobeDoc from "../../../../src/pages/apis/accessibility-auto-tag-api/accessibility-adobe-doc.md";
import AccessibilityStepper from "../../../../src/pages/apis/accessibility-auto-tag-api/accessibility-stepper.md";
import { AutoTag } from "../../../../src/components/auto-tag";
import * as React from 'react';
export default {
  AutoTagAPI,
  BenefitsOfAccessibilityTitle,
  BenefitsOfAccessibilityContent,
  TechnicalUsecase,
  IndustryUsecase,
  PdfAccessibility,
  AccessibilityAdobeDoc,
  AccessibilityStepper,
  AutoTag,
  React
};